export default "__VITE_ASSET__ea2fc2e3__"